import { Swiper } from "swiper/react"; // Import Swiper React components
import "swiper/css"; // Import Swiper styles
import { useContext } from "react";
import ProductContext from "../contexts/ProductContext";
import { FreeMode, Scrollbar, Mousewheel } from "swiper";
import "./CustomSwiper.scss";
import clsx from "clsx";

const CustomSwiper = ({
  className,
  centeredSlides,
  mousewheel,
  scrollbar,
  children,
  isBigItem,
}) => {
  const context = useContext(ProductContext);
  const { setPageNumber, setActiveIndex, activeIndex, swiperRef } = context;
  // let { oldKeyward } = context;
  return (
    <Swiper
      ref={swiperRef}
      className={clsx(
        "generic-swiper swiper-generic-style",
        className,
        isBigItem ? "add-item-hover" : ""
      )}
      spaceBetween={24}
      slidesPerView={`auto`}
      scrollbar={scrollbar}
      mousewheel={mousewheel}
      freeMode={true}
      centeredSlides={centeredSlides}
      preventClicks={true}
      preventClicksPropagation={true}
      modules={[FreeMode, Scrollbar, Mousewheel]}
      onSlideChange={(swiper) => {
        // console.log("onSlideChange", swiper.activeIndex);
        setActiveIndex(swiper.activeIndex);
      }}
      // onInit={(swiper) => {
      //   // console.log("onInit", swiper.activeIndex);
      // }}
      // onUpdate={(swiper) => {
      //   // console.log("onUpdate oldKeyward", oldKeyward.current);
      //   // console.log("onUpdate keyword", keyword);

      //   if (
      //     oldKeyward.current.toLowerCase().trim() !==
      //     keyword.toLowerCase().trim()
      //   ) {
      //     swiper.slideTo(0);
      //   }
      // }}
      onReachEnd={(swiper) => {
        // console.log("end reached", swiper.activeIndex);
        if (activeIndex === 0) return;
        // oldKeyward = keyword;
        // console.log("onReachEnd oldKeyward", oldKeyward.current);
        // console.log("onReachEnd keyword", keyword);

        setPageNumber((prev) => prev + 1);
      }}
      // onReachBeginning={(swiper) => {
      //   //  console.log("start reached");
      //   //  if (pageNumber === 1) return;
      //   //  setPageNumber((prev) => prev - 1);
      //   // console.log("beginning reached", swiper.activeIndex);
      // }}
    >
      {children}
    </Swiper>
  );
};
export default CustomSwiper;
